import React, { useState } from "react";

// Material UI Components
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

// Components
import OrdersHeader from "./LatestOrdersHeader";
import LatestOrdersBody from "./LatestOrdersBody";
import Paginate from "../../../../Utilities/Paginate";

// This component will hold the latest orders data
const LatestOrdersTable = ({ orders }) => {
  const [ordersData] = useState(orders);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("orderDate");

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  const handleRequestSort = (e, id) => {
    const isAsc = orderBy === id && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(id);
  };

  const stableSort = (array, comparator) => {
    return array
      .map((el, index) => [el, index])
      .sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
      })
      .map((el) => el[0]);
  };

  const createData = (
    id,
    customerName,
    campaignName,
    orderTotal,
    orderStatus,
    orderMessage,
    scn,
    cardType,
    brand,
    orderDate
  ) => {
    return {
      id,
      customerName,
      campaignName,
      orderTotal,
      orderStatus,
      orderMessage,
      scn,
      cardType,
      brand,
      orderDate,
    };
  };

  const Orders = ordersData.map(
    ({
      customerId,
      customerName,
      campaignName,
      orderTotal,
      orderStatus,
      orderMessage,
      scn,
      cardType,
      brand,
      orderDate,
    }) =>
      createData(
        customerId,
        customerName,
        campaignName,
        orderTotal,
        orderStatus,
        orderMessage,
        scn,
        cardType,
        brand,
        orderDate
      )
  );

  return (
    <div className="root">
      <TableContainer>
        <Table className="table" size={"small"}>
          <OrdersHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <LatestOrdersBody
            orders={Orders}
            page={page}
            rowsPerPage={rowsPerPage}
            stableSort={stableSort}
            getComparator={getComparator}
            order={order}
            orderBy={orderBy}
          />
        </Table>
      </TableContainer>
      <Paginate totalRowCount={Orders.length} page={page} rowsPerPage={rowsPerPage} handleChange={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} showCorePaginate={false} />
    </div>
  );
};

export default LatestOrdersTable;
